import {get, isNumber} from "lodash";
import {EmptyString, IPlayer, Nullable} from "modules/types";
import {PlayerPoolFilterStats, PlayerPositionEnum} from "modules/enums";

export const filterPlayersBySearch = (player: IPlayer, search: string = "") => {
	if (!search) {
		return true;
	}

	return (
		player.firstName.toLowerCase().includes(search.toLowerCase()) ||
		player.lastName.toLowerCase().includes(search.toLowerCase())
	);
};

export const filterByPosition = (
	player: IPlayer,
	position: EmptyString<PlayerPositionEnum | number>
) => {
	if (!position || position === 0) {
		return true;
	}
	return player.position === position;
};

export const filterBySquad = (player: IPlayer, squadId: Nullable<number | "">) => {
	if (!squadId) {
		return true;
	}

	return player.squadId === squadId;
};

const statsKeys = {
	[PlayerPoolFilterStats.PassTouchdowns]: {
		[PlayerPositionEnum.QB]: "passingTouchdowns",
	},
	[PlayerPoolFilterStats.ReceivingTouchdowns]: {
		[PlayerPositionEnum.WR]: "receivingTouchdowns",
		[PlayerPositionEnum.RB]: "receivingTouchdowns",
	},
	[PlayerPoolFilterStats.RushingTouchdowns]: {
		[PlayerPositionEnum.RB]: "rushingTouchdowns",
	},
	[PlayerPoolFilterStats.PassYards]: {
		[PlayerPositionEnum.QB]: "passingYards",
	},
	[PlayerPoolFilterStats.ReceivingYards]: {
		[PlayerPositionEnum.WR]: "receivingYards",
		[PlayerPositionEnum.RB]: "receivingYards",
	},
	[PlayerPoolFilterStats.RushingYards]: {
		[PlayerPositionEnum.RB]: "rushingYards",
	},
	[PlayerPoolFilterStats.Sacks]: {
		[PlayerPositionEnum.DL]: "sacks",
		[PlayerPositionEnum.LB]: "sacks",
		[PlayerPositionEnum.DB]: "sacks",
	},
	[PlayerPoolFilterStats.DefensiveTackles]: {
		[PlayerPositionEnum.DL]: "tackles",
		[PlayerPositionEnum.LB]: "tackles",
		[PlayerPositionEnum.DB]: "tackles",
	},
	[PlayerPoolFilterStats.Interceptions]: {
		[PlayerPositionEnum.DB]: "interceptions",
		[PlayerPositionEnum.LB]: "interceptions",
	},
	[PlayerPoolFilterStats.DefensiveTacklesForLoss]: {
		[PlayerPositionEnum.LB]: "tacklesForLoss",
		[PlayerPositionEnum.DB]: "tacklesForLoss",
	},
	[PlayerPoolFilterStats.FieldGoalsMade]: {
		[PlayerPositionEnum.K]: "fieldGoalsMade",
	},
	[PlayerPoolFilterStats.FieldGoalPercentage]: {
		[PlayerPositionEnum.K]: "fieldGoalsPct",
	},
	[PlayerPoolFilterStats.GamesPlayed]: {
		[PlayerPositionEnum.OL]: "gamesPlayed",
	},
	// [PlayerPoolFilterStats.GamesStarted]: {
	// 	[PlayerPositionEnum.OL]: "gamesStarted",
	// },
	[PlayerPoolFilterStats.AveragePuntYards]: {
		[PlayerPositionEnum.P]: "averageYards",
	},
	[PlayerPoolFilterStats.PuntYards]: {
		[PlayerPositionEnum.P]: "puntYards",
	},
	[PlayerPoolFilterStats.ReturnTouchdowns]: {
		[PlayerPositionEnum.ST]: "returnsTouchdowns",
	},
	[PlayerPoolFilterStats.SpecialTeamsTackles]: {
		[PlayerPositionEnum.ST]: "specialTeamsTackles",
	},
};

export const sortByStats = (player: IPlayer, stats: PlayerPoolFilterStats | number) => {
	if (isNumber(stats)) {
		return true;
	}

	const key = get(statsKeys, `${stats}.${player.position}`, "") as string;

	return get(player.stats, key, 0) as number;
};
